var config = require('../config.js')
module.exports = {
  pointCommonRuleGet: config.host + '/market/api/v1/pointCommonRule/get', // 获取积分通用规则
  pointCommonRuleInitInner: config.host + '/market/api/v1/pointCommonRule/init/inner', // 初始化积分通用规则
  pointCommonRuleUpdate: config.host + '/market/api/v1/pointCommonRule/update', // 修改积分通用规则
  pointExpirePointInner: config.host + '/market/api/v1/point/expirePoint/inner', // 过期积分
  pointGet: config.host + '/market/api/v1/point/get', // 获取商家积分详情
  pointInitInner: config.host + '/market/api/v1/point/init/inner', // 初始化商家积分
  pointFetchRuleAdd: config.host + '/market/api/v1/pointFetchRule/add', // 商家积分获取规则新增
  pointFetchRuleBanAndOpen: config.host + '/market/api/v1/pointFetchRule/banAndOpen', // 禁用启用商家积分获取规则
  pointFetchRuleGet: config.host + '/market/api/v1/pointFetchRule/get', // 获取商家积分获取规则
  pointFetchRuleListByPage: config.host + '/market/api/v1/pointFetchRule/listByPage', // 商家积分获取规则分页查询
  pointFetchRuleUpdate: config.host + '/market/api/v1/pointFetchRule/update', // 商家积分获取规则修改
  userPointGetC: config.host + '/market/api/v1/userPoint/get/c', // 积分查询
  userPointGetPointRuleC: config.host + '/market/api/v1/userPoint/getPointRule/c', // 积分规则查询
  // userPointGetPointRuleC2: config.host + '/market/api/v1/userPoint/getShowPointRule/c', // 积分规则查询
  userPointGetPointRuleC2: config.host + '/market/api/v1/userPoint/getShowPointRule/v2/c', // 积分规则查询
  // userPointGetPointRuleC2: config.host + '/market/api/v1/userPoint/getShowPointRule/v4/c', // 积分规则查询
  userPointPointDetailByPageC: config.host + '/market/api/v1/userPoint/pointDetailByPage/c', // 积分明细查询
  userMemberGetC: config.host + '/market/api/v1/userMember/get/c', // 会员查询
  userMemberGetC2: config.host + '/market/api/v1/userMember/getMemberRankDiscount/c', // 会员查询并发简化
  userMemberInfoC: config.host + '/market/api/v1/userMember/getInfo/c', // 会员查询简版
  judgeAdaptationPattern: config.host + '/market/api/v1/adaptationPattern/judge/c', // 获取适用模式
  getBalanceAndCardByRankId: config.host + '/market/api/v1/memberRank/getBalanceAndCardByRankId/c', //  查询会员id 下是否有余额或者礼品卡

  getMemberBenefitList: config.host + '/app-api/user/member-benefit/list',
  getMemberBenefit: config.host + '/app-api/user/member-benefit/get'
}